var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "General buttons/Switch/Tooltip"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 63"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 31",
    cx: 8.5,
    cy: 9,
    r: 8.5,
    strokeWidth: 0,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 627",
    d: "M5.4082 5.90906L11.59 12.0909",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 628",
    d: "M11.5898 5.90906L5.40803 12.0909",
    strokeWidth: 2,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.2fa3b0b580cf47c9bcd39a7dc3f4e718.svg";
export { ForwardRef as ReactComponent };